<template>
  <a-drawer
    width="60%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @cancel="onClose"
    @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <div class="live-info-container">
        <a-card
          :bordered="false"
          :title="$t('直播信息')"
          :headStyle="{'background-color':'#f3f3f3','height': '40px','border-bottom': '1px solid #DDD'}"
          :bodyStyle="{'background-color':'#fbfbfb', 'padding': '24px'}">
          <div class="info-list">
            <div class="info-item">
              <div class="info-label">{{ $t('主题') }}：</div>
              <div class="info-content">{{ shareInfo.theme }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">{{ $t('封面') }}：</div>
              <div class="info-content">
                <img
                  :src="shareInfo.thumb"
                  class="cover-img"
                  @click="handleImagePreview(shareInfo.thumb)"/>
              </div>
            </div>

            <div class="info-item">
              <div class="info-label">{{ $t('推流地址') }}：</div>
              <div class="info-content">{{ shareInfo.pushUrl }}</div>
            </div>
            <div class="info-item">
              <div class="info-label">{{ $t('obs服务器') }}：</div>
              <div class="info-content">rtmp://im.push.yanghuitech.com/live/</div>
            </div>
            <div class="info-item">
              <div class="info-label">{{ $t('obs token') }}：</div>
              <div class="info-content">{{ shareInfo.obsPushUrl }}</div>
            </div>
            <div class="info-item">
              <div class="info-label">{{ $t('拉流地址') }}：</div>
              <div class="info-content">{{ shareInfo.pullUrl }}</div>
            </div>
          </div>
        </a-card>
      </div>

      <div class="bottom-control">
        <a-space>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>

    </a-form-model>

    <a-modal :visible="previewVisible" :footer="null" @cancel="handlePreviewCancel">
      <img style="width: 100%" :src="previewImage"/>
    </a-modal>

  </a-drawer>
</template>

<script>
import { getCommunityLive } from '@/api/community/live'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import vueQr from 'vue-qr'

export default {
  name: 'CreateFormShare',
  props: {},
  components: {
    CustomDictTag,
    // 选择商品
    vueQr
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',

      shareParam: {
        id: null,
        type: 'liveShareUrl',
        videoType: ''
      },
      shareInfo: {},
      // 选择商品
      categoryList: [],
      // 1增加,2修改
      formType: 1,
      open: false,
      previewVisible: false,
      previewImage: '',
      qrCodeImage: '' // 用于存储生成的二维码图片
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    previewVideoCancel() {
      this.previewVideoVisible = false
    },
    // 表单重置
    reset() {
      this.formType = 1
    },

    /** 新增按钮操作 */
    handleShare(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('分享')
      getCommunityLive({ 'id': row.id }).then(response => {
        this.shareInfo = response.data
      })
    },

    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },

    /** 提交按钮 */

    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },

    // 选择商品
    handleImagePreview(imageUrl) {
      this.previewImage = imageUrl
      this.previewVisible = true
    },
    handlePreviewCancel() {
      this.previewVisible = false
    },
    handleQrcodePreview() {
      if (this.qrCodeImage) {
        this.previewImage = this.qrCodeImage
        this.previewVisible = true
      }
    },
    onQRGenerated(dataUrl) {
      // 二维码生成完成后的回调
      this.qrCodeImage = dataUrl
    }
  }
}
</script>

<style lang="less" scoped>
.live-info-container {
  padding: 0 24px;
}

.info-list {
  .info-item {
    display: flex;
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }

    .info-label {
      width: 120px;
      color: rgba(0, 0, 0, 0.85);
      line-height: 32px;
      font-size: 14px;
    }

    .info-content {
      flex: 1;
      line-height: 32px;
      color: rgba(0, 0, 0, 0.65);
      word-break: break-all;
    }
  }
}

.cover-img {
  width: 150px;
  height: 150px;
  object-fit: cover;
  border-radius: 2px;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    opacity: 0.8;
  }
}

.bottom-control {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 4px 4px;
}

.qrcode-wrapper {
  display: inline-block;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    opacity: 0.8;
  }

  /deep/ canvas {
    border-radius: 4px;
  }
}
</style>
